import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const LAPTOP = 'https://cdn.magicpatterns.com/patterns/generated-images/1afd7620-9db5-4262-9698-918a4abe1b08.jpg';
export function BuyMore() {
  return <section className="w-full bg-white py-20" data-id="element-12" data-mp="knlzaxzft4vd">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8" data-id="element-13" data-mp="or0g3qv79p9v">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.55
      }} data-id="element-14" data-mp="tq3onlae2dml">
          <h2 className="font-display text-4xl font-extrabold leading-tight text-ardis-green sm:text-5xl" data-id="element-15" data-mp="18dyd2phd5vtv">
            Koop meer
            <br data-id="element-16" data-mp="1ce8nqfg3paf2" />
            Betaal minder!
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600" data-id="element-17" data-mp="1hfxvnm8117yx">
            Met een ruim assortiment aan voedingsmiddelen, dranken, artikelen
            voor huis en elektronica tegen scherpe prijzen is A.D. INTER de
            ideale partner voor uw groothandelsaankopen. Hoe meer u koopt, hoe
            meer u bespaart.
          </p>
          <a href="#categories" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ardis-green px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-ardis-green-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-ardis-green focus-visible:ring-offset-2" data-id="element-18" data-mp="31lccndnce664">
            Bekijk onze categorieën
            <ArrowRightIcon className="h-4 w-4" data-id="element-19" data-mp="3pgyin03z2tzk" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.55,
        delay: 0.1
      }} className="flex items-center justify-center gap-4" data-id="element-20" data-mp="3kjoml1m2vk2r">
          {[0, 1, 2].map(n => <motion.img key={n} src={LAPTOP} alt="Laptop verkrijgbaar bij A.D. INTER" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15 + n * 0.1
        }} className={`w-1/3 rounded-lg object-contain ${n === 1 ? 'scale-110' : 'opacity-90'}`} data-id="element-21" data-mp="21m25pe34liju" />)}
        </motion.div>
      </div>
    </section>;
}